import { useContext } from 'react'
import { useMutation } from 'react-query'
import { apiPostQuery } from 'api'
import AuthContext from 'context/auth-context'

// Asks the API to draft a short, copy-paste-ready cardholder email for a
// flagged transaction the user is processing on the monitoring page. The
// backend grounds the email in the transaction, the failed control analytics,
// the linked policy rules, and the cardholder name. When `highRisk` is set the
// email is instead framed around the transaction's elevated risk score and the
// full set of analytics behind it.
//
// Invoke `mutate({ transactionId, highRisk })`; resolves to `{ subject, body }`.
export default function useTransactionEmailDraft({ options = {} } = {}) {
  const token = useContext(AuthContext)

  return useMutation(
    async ({ transactionId, highRisk = false }) =>
      apiPostQuery({
        url: `transactions/${transactionId}/email_draft`,
        token,
        params: { high_risk: highRisk }
      }),
    options
  )
}
